import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './RacingThemeListingQuickInfo.module.css';

const QuickIcon = ({ name }) => {
  const common = {
    width: 18,
    height: 18,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.8,
    'aria-hidden': true,
  };
  switch (name) {
    case 'shipping':
      return (
        <svg {...common}>
          <rect x="1" y="3" width="15" height="13" rx="1" />
          <path d="M16 8h4l3 3v5h-7V8z" />
          <circle cx="5.5" cy="18.5" r="2.5" />
          <circle cx="18.5" cy="18.5" r="2.5" />
        </svg>
      );
    case 'returns':
      return (
        <svg {...common}>
          <polyline points="1 4 1 10 7 10" />
          <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" />
        </svg>
      );
    case 'support':
      return (
        <svg {...common}>
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        </svg>
      );
    default:
      return (
        <svg {...common}>
          <path d="M20 6L9 17l-5-5" />
        </svg>
      );
  }
};

/**
 * Shop listing quick info strip.
 */
const RacingThemeListingQuickInfo = props => {
  const { items, className } = props;

  if (!items?.length) {
    return null;
  }

  return (
    <ul className={classNames(css.root, className)}>
      {items.map(item => (
        <li key={item.label} className={css.item}>
          <span className={css.icon}>
            <QuickIcon name={item.icon} />
          </span>
          <span className={css.copy}>
            <span className={css.label}>{item.label}</span>
            <span className={css.value}>{item.value}</span>
          </span>
        </li>
      ))}
    </ul>
  );
};

RacingThemeListingQuickInfo.defaultProps = {
  className: null,
  items: [],
};

RacingThemeListingQuickInfo.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string,
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ),
};

export default RacingThemeListingQuickInfo;
